import React from "react";

const CustomErrorField = ({ message, ...rest }) => (
	<div {...rest}>{message}</div>
);
export default CustomErrorField;
